export const state = {
    kanban: {
        availableStatuses: [],
        columns: []
    },
    table: {
        columns: [],
        name: '',
        addable: null,
        searchable: null,
        showAll: null,
        sortable: null,
        downloadable: null,
        buttonKey: null
    },
    boardId: null,
    tableId: null,
    teamtaskName: null,
    addButtonLink: null,
    addButtonName: null,
}

export const mutations = {
    SET_TABLE_NAME(state, payload) {
        state.table.name = payload
    },
    SET_TABLE_COLUMNS(state, payload) {
        state.table.columns = [...payload]
    },
    SET_AVAILABLE_STATUSES(state, payload) {
        state.kanban.availableStatuses = payload
    },
    UPDATE_AVAILABLE_STATUSES(state, payload) {
        state.kanban.availableStatuses.push(...payload)
    },
    SET_COLUMNS(state, payload) {
        state.kanban.columns = payload
    },
    ADD_COLUMNS(state, payload) {
        state.kanban.columns.push(payload)
    },
    REMOVE_COLUMNS(state, payload) {
        state.kanban.columns.splice(payload, 1)
    },
    SET_INITIAL_DATA(state, payload) {
        state.boardId = payload.boardId
        state.tableId = payload.tableId
        state.teamtaskName = payload.teamtaskName
        state.table.addable = payload.addable
        state.table.searchable = payload.searchable
        state.table.sortable = payload.sortable
        state.table.showAll = payload.showAll
        state.table.downloadable = payload.downloadable
        state.table.buttonKey = payload.buttonKey
        state.addButtonName = payload.buttonName
        state.addButtonLink = payload.buttonLink
    },
}

export const actions = {
    setAvailableStatuses({ commit }, payload) {
        commit('SET_AVAILABLE_STATUSES', payload)
    },
    updateAvailableStatuses({ commit }, payload) {
        commit('UPDATE_AVAILABLE_STATUSES', payload)
    },
    setKanbanColumns({ commit }, payload) {
        commit('SET_COLUMNS', payload)
    },
    setTableColumns({ commit }, payload) {
        commit('SET_TABLE_COLUMNS', payload)
    },
    setTableName({ commit }, payload) {
        commit('SET_TABLE_NAME', payload)
    },
    addKanbanColumns({ commit }, payload) {
        commit('ADD_COLUMNS', payload)
    },
    removeKanbanColumns({ commit }, payload) {
        commit('REMOVE_COLUMNS', payload)
    },
    setInitialData({ commit }, payload) {
        commit('SET_INITIAL_DATA', payload)
    },

}
